/* A hook for getting access to the context value */
import React from 'react';
import { SidesheetContextV3 } from 'Components/utils/Sidesheet/SidesheetContextV3';

const useSidesheetV3 = () => React.useContext(SidesheetContextV3);

export default useSidesheetV3;
